module.exports = __webpack_public_path__ + "img/cpjs10.839a50fd.png";